<template>
  <div class="image-viewer" data-cy="image-viewer">
    <IconButton
      class="image-viewer__close-button"
      data-cy="image-viewer-close-button"
      width="20px"
      height="auto"
      icon="times"
      @click="close"
    />

    <div class="image-viewer__carousel-container">
      <img :src="image" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ImageViewer",

  components: {
    IconButton
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true
    },

    image: {
      type: String,
      required: true
    }
  },

  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  }
});
</script>

<style lang="scss" scoped>
.image-viewer {
  background: $black;
  color: $white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.image-viewer__close-button {
  color: $white;
  position: absolute;
  top: 0.3rem;
  right: 0.6rem;
}

.image-viewer__carousel-container {
  width: 100%;
}
</style>
